import { getI18n } from 'src/i18n/i18n.middleware'
import { createHydratingClientLoader, dynamic } from 'src/utils/ssr'
import { SITE_NAME, staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/_app.event.$eventRoute.$'

const getClientModule = () =>
  import('src/clientRoutes/_app.event.$eventRoute.$')

export const handle = {
  name: 'events',
  hideMembershipBanner: true,
  track: ({ params }: { params: { eventRoute?: string } }) => ({
    scene: 'event',
    section: params.eventRoute,
  }),
}

/**
 * SSR loader for event pages.
 * Source: https://github.com/troph-team/pixai/blob/main/packages/pixai-server/src/ssr/router.ts#L443-L492
 */
export function loader({ params, request, context }: Route.LoaderArgs) {
  const eventRoute = params.eventRoute || 'event'

  const { t, exists } = getI18n(context)

  // Try event-specific i18n keys first, fallback to generic
  const titleKey = `server:meta.event.${eventRoute}.title`
  const descKey = `server:meta.event.${eventRoute}.description`
  const imageKey = `server:meta.event.${eventRoute}.image`

  const title = exists(titleKey) ? t(titleKey) : `Event - ${eventRoute}`
  return staticMetaLoader({
    requestUrl: request.url,
    title: `${title} | ${SITE_NAME}`,
    description: exists(descKey)
      ? t(descKey)
      : t('server:meta.event.description'),
    image: exists(imageKey) ? t(imageKey) : undefined,
  })
}

/** Meta function for SSR SEO. */
export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export const clientLoader =
  createHydratingClientLoader<Awaited<ReturnType<typeof loader>>>(
    getClientModule,
  )

export default dynamic(getClientModule, { ssr: false })
